import { CartItemValidation } from "./dto";
import { Customer } from "../customer";
import { AccountDomain } from "../accountDomain";

/**
 * Entidad Cart
 * Define el carrito de compras de un cliente en el sitio web.
 */

export interface Cart {
    id: string;
    code: string;
    customerId?: string;
    sessionId?: string;
    items: CartItem[];
    currency: string;
    subtotal: number;
    total: number;
    deliveryType: CartDeliveryType;
    itemCount: number;
    createdAt: Date;
    updatedAt: Date;
    status: CartStatus;
    source: CartSource;
    sourceAccountDomainId?: string;
    recoveryToken?: string;
    customerNote?: string;
    hasIssues: boolean;              // Indica si el carrito tiene problemas que resolver
    issuesCount: number;             // Número de items con problemas
    // Nuevos campos de precios
    subtotalPrice?: number;
    totalDiscounts?: number;
    totalShippingPrice?: number;
    totalTax?: number;
    totalPrice?: number;
    taxDetails?: any;

    customer?: Customer | null;
    accountDomain?: AccountDomain;
}

export interface CartItem {
    id: string;
    productId: string;
    productVariantId: string;
    name: string;
    unitPrice: number;                   // Precio cuando se agregó al carrito
    quantity: number;
    image?: string;
    thumbnailUrl?: string;           // URL del thumbnail de la variante
    sku?: string;
    attributeDetails: CartItemAttributeDetail[];  // Detalles legibles de atributos
    
    validation?: CartItemValidation;  // Información de validación del item en dto
}


export interface CartItemAttributeDetail {
    name: string;        // Nombre del atributo (ej: "Talle", "Color")
    value: string;       // Valor del atributo (ej: "M", "Rojo")
    type?: string;       // Tipo del atributo (opcional)
}

export enum CartStatus {
    ACTIVE = 'ACTIVE',
    LOCKED = 'LOCKED',
    EXPIRED = 'EXPIRED',
    CONVERTED = 'CONVERTED',
    ABANDONED = 'ABANDONED',
    MERGED = 'MERGED'
}

export enum CartSource {
    WEB = 'WEB',
    POS = 'POS',
    API = 'API'
}

export enum CartDeliveryType {
    DELIVERY = 'delivery',
    PICKUP = 'pickup'
}




